import { render, staticRenderFns } from "./ThuxVueFileAgent.vue?vue&type=template&id=25a7b517&"
import script from "./ThuxVueFileAgent.vue?vue&type=script&lang=js&"
export * from "./ThuxVueFileAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports